import { Dropdown } from "../../../Components/Form/Dropdown";
import { TConfigOptionName } from "./types";

export class ConfigOption {
    private readonly changeListener: () => void;
    private readonly element: Dropdown;

    constructor(elem: Dropdown, configuratorNode: HTMLElement) {
        this.element = elem;
        this.changeListener = () => {
            configuratorNode.dispatchEvent(new CustomEvent("config", { detail: this }));
        };
        this.element.addEventListener("change", this.changeListener);
    }

    /**
     * disable invalid options
     * @param validValues
     */
    public set validValues(validValues: string[]) {
        this.silent = true;
        this.element.options.forEach((option: HTMLOptionElement) => {
            option.disabled = !validValues.includes(option.value);
        });
        if (this.options[this.selectedIndex].disabled) {
            const firstAvailableOption = this.options.find((option: HTMLOptionElement) => !option.disabled);
            this.value = firstAvailableOption.value;
        }
        this.silent = false;
    }

    public set silent(v: boolean) {
        if (v) {
            this.element.removeEventListener("change", this.changeListener);
        } else {
            this.element.addEventListener("change", this.changeListener);
        }
    }

    public get name(): TConfigOptionName {
        return this.element.name as TConfigOptionName;
    }

    public get index(): number {
        return parseInt(this.element.name.replace(/\D/g, ""));
    }

    public set value(v: string) {
        this.element.value = v;
    }

    public get value(): string {
        return this.element.value;
    }

    public get options(): HTMLOptionElement[] {
        return this.element.options as HTMLOptionElement[];
    }

    public get selectedIndex(): number {
        return this.element.selectedIndex;
    }
}
